import { apiClient, v2ApiClient } from './apiClient';

export const examService = {
  async getAssignedExams({ classId, teacherId, status, examType, sortBy = 'newest', page = 1, pageSize = 10 } = {}) {
    const params = new URLSearchParams();
    if (classId) params.append('classId', classId);
    if (teacherId) params.append('teacherId', teacherId);
    if (status) params.append('status', status);
    if (examType) params.append('examType', examType);
    if (sortBy) params.append('sortBy', sortBy);
    if (page) params.append('page', page);
    if (pageSize) params.append('pageSize', pageSize);

    const response = await v2ApiClient.get(`/lms/exam/student/assigned?${params.toString()}`);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to retrieve assigned exams');
  },

  async getExamDetails(classExamId) {
    const response = await v2ApiClient.get(`/lms/exam/student/${classExamId}/details`);
    return response;
  },

  async getExamResult(classExamId, examId) {
    const query = examId ? `?examId=${examId}` : '';
    const response = await v2ApiClient.get(`/lms/exam/student/${classExamId}/result${query}`);
    return response;
  },

  async startExam(classExamId, examId) {
    const query = examId ? `?examId=${examId}` : '';
    const response = await v2ApiClient.get(`/lms/exam/student/${classExamId}/start${query}`);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to start exam');
  },

  async saveQuestionAnswer(classExamId, payload, activeSessionToken) {
    const headers = activeSessionToken ? { 'x-active-session-token': activeSessionToken } : {};
    const response = await v2ApiClient.post(`/lms/exam/student/${classExamId}/save-question`, payload, { headers });
    if (response && response.isSuccessful) {
      return response;
    }
    const error = new Error(response?.message || 'Failed to save question progress');
    error.data = response;
    throw error;
  },

  async submitMcqExam(classExamId, payload, activeSessionToken) {
    const headers = activeSessionToken ? { 'x-active-session-token': activeSessionToken } : {};
    const response = await v2ApiClient.post(`/lms/exam/student/${classExamId}/submit-mcq`, payload, { headers });
    if (response && response.isSuccessful) {
      return response;
    }
    const error = new Error(response?.message || 'Failed to submit exam');
    error.data = response;
    throw error;
  },

  async startEssayExam(classExamId, examId) {
    const query = examId ? `?examId=${examId}` : '';
    const response = await v2ApiClient.post(`/lms/exam/student/${classExamId}/start-essay${query}`);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to start essay exam');
  },

  async submitEssayExam(classExamId, formData, activeSessionToken) {
    const headers = activeSessionToken ? { 'x-active-session-token': activeSessionToken } : {};
    const response = await v2ApiClient.post(`/lms/exam/student/${classExamId}/submit-essay`, formData, { headers });
    if (response && response.isSuccessful) {
      return response;
    }
    const error = new Error(response?.message || 'Failed to submit exam');
    error.data = response;
    throw error;
  },

  async generateExamPdf(examId) {
    const response = await apiClient.post(`/exams/${examId}/generate-pdf`, {}, { responseType: 'blob' });
    return response;
  },

  async downloadExamPaper(paperId) {
    const response = await apiClient.get(`/grading/papers/${paperId}/download`, { responseType: 'blob' });
    return response;
  }
};

export default examService;
